import DetailOrderList from "./detailOrderList.jsx";

export default DetailOrderList;
